import Vue from 'vue'

export default ({ store, app: { router, context } }, inject) => {

    if (!process.client)
        return;

    const eventBus = {}

    eventBus.install = function (Vue) {
        Vue.prototype.$bus = new Vue()
    }

    Vue.use(eventBus)
}
